module.exports = __webpack_public_path__ + "static/img/bcg.f6a6b802.webp";